import React, { useEffect, useState, useRef } from 'react';

import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

import { MONETIZE_DETAILS } from '../constants';
import { MonetizeStackCard, MonetizeCardDetail } from './index';

function MonetizeCardStackSection() {
  const isExtraSmallScreen = useMediaQuery('(max-width:740px)');
  const [translateY, setTranslateY] = useState(isExtraSmallScreen ? 130 : 320);

  const [scrollClass1, setScrollClass1] = useState('scroll-hide');
  const [scrollClass2, setScrollClass2] = useState('scroll-hide');
  const [scrollClass3, setScrollClass3] = useState('scroll-hide');
  const [scrollClass4, setScrollClass4] = useState('scroll-hide');

  const [textClass1, setTextClass1] = useState('card-text-hide');
  const [textClass2, setTextClass2] = useState('card-text-hide');
  const [textClass3, setTextClass3] = useState('card-text-hide');
  const [textClass4, setTextClass4] = useState('card-text-hide');

  const [scrollStyles1, setScrollStyles1] = useState({
    display: 'none',
    transform: 'translateX(0%) translateZ(0px) translateY(0%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)',
  });
  const [scrollStyles2, setScrollStyles2] = useState({
    display: 'none',
    transform: 'translateX(0%) translateZ(0px) translateY(0%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)',
  });
  const [scrollStyles3, setScrollStyles3] = useState({
    display: 'none',
    transform: 'translateX(0%) translateZ(0px) translateY(0%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)',
  });
  const [scrollStyles4, setScrollStyles4] = useState({
    display: 'none',
    transform: 'translateX(0%) translateZ(0px) translateY(0%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)',
  });
  const [scrollStyles, setScrollStyles] = useState({
    transform: 'translateX(0%) translateZ(0px) translateY(0%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)',
  });

  const ref = useRef<HTMLDivElement>(null);
  const ref1 = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const ref3 = useRef<HTMLDivElement>(null);
  const ref4 = useRef<HTMLDivElement>(null);
  const ref5 = useRef<HTMLDivElement>(null);

  const scrollStylesArray = [
    setScrollStyles1,
    setScrollStyles2,
    setScrollStyles3,
    setScrollStyles4,
  ];
  const scrollClasses = [setScrollClass1, setScrollClass2, setScrollClass3, setScrollClass4];
  const textClasses = [setTextClass1, setTextClass2, setTextClass3, setTextClass4];

  useEffect(() => {
    const handleScroll = () => {
      const scrolledFromTop = window.scrollY;
      const viewportHeight = window.innerHeight;
      const scrollCutOff = 530;

      let distanceFromBottom = 0;

      if (
        ref.current &&
        ref1.current &&
        ref2.current &&
        ref3.current &&
        ref4.current &&
        ref5.current
      ) {
        const elementPositionY = ref.current.getBoundingClientRect().top + window.scrollY;

        distanceFromBottom = scrolledFromTop + viewportHeight - elementPositionY - 480;

        if (distanceFromBottom > 0) {
          const max = scrollClasses.length;

          for (let i = 0; i < max && distanceFromBottom < scrollCutOff; i++) {
            const offset = (i + 1) * 130;
            const dist = distanceFromBottom - offset > 0 ? -(distanceFromBottom - offset) / 4.5 : 0;
            scrollStylesArray[i]({
              display: 'flex',
              transform: `translateX(0%) translateZ(0px) translateY(${dist}%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)`,
            });

            if (distanceFromBottom - offset > 0) {
              scrollClasses[i]('scroll-fade-in');
              textClasses[i]('card-text-fade-in');
            } else {
              scrollClasses[i]((prev) => (prev === 'scroll-fade-in' ? 'scroll-reverse' : prev));
              textClasses[i]((prev) => (prev === 'card-text-fade-in' ? 'card-text-reverse' : prev));
            }
          }
          if (distanceFromBottom >= scrollCutOff) {
            for (let j = 0; j < max; j++) {
              scrollClasses[j]('scroll-fade-in');
              textClasses[j]('card-text-fade-in');
            }
          }

          const newTranslateY = Math.min(
            isExtraSmallScreen ? 320 : 560,
            Math.max(300 + distanceFromBottom - 100, isExtraSmallScreen ? 130 : 320)
          );
          setTranslateY(newTranslateY);

          if (distanceFromBottom < scrollCutOff) {
            setScrollStyles({
              transform: `translateX(0%) translateZ(0px) translateY(-${
                distanceFromBottom / 4.5
              }%) matrix(0.87, -0.5, 0.87, 0.5, 0, 0)`,
            });
          }
        } else {
          scrollStylesArray.forEach((setScrollStyle) => {
            setScrollStyle({
              display: 'none',
              transform:
                'translateX(0%) translateZ(0px) translateY(0%)  matrix(0.87, -0.5, 0.87, 0.5, 0, 0)',
            });
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [
    scrollClass1,
    scrollClass2,
    scrollClass3,
    scrollClass4,
    translateY,
    textClass1,
    textClass2,
    textClass3,
    textClass4,
  ]);

  return (
    <>
      <Grid
        className={'home-page__monetize-stack-section-container'}
        container={true}
        justifyContent={'center'}
        spacing={3}
        data-qa="monetize-card-stack-section"
        ref={ref}
        style={{
          paddingTop: `${translateY}px`,
          transition: 'padding-top 0.3s ease-out',
        }}
      >
        <MonetizeStackCard
          id={'home-page__card-data'}
          cardInfo={MONETIZE_DETAILS.data}
          scrollStyles={scrollStyles4}
          forwardedRef={ref1}
          textStyle={textClass4}
        />
        <MonetizeStackCard
          id={'home-page__card-revenue'}
          cardInfo={MONETIZE_DETAILS.revenue}
          scrollStyles={scrollStyles3}
          forwardedRef={ref2}
          textStyle={textClass3}
        />
        <MonetizeStackCard
          id={'home-page__card-ops'}
          cardInfo={MONETIZE_DETAILS.ops}
          scrollStyles={scrollStyles2}
          forwardedRef={ref3}
          textStyle={textClass2}
        />
        <MonetizeStackCard
          id={'home-page__card-sdk'}
          cardInfo={MONETIZE_DETAILS.sdk}
          scrollStyles={scrollStyles1}
          forwardedRef={ref4}
          textStyle={textClass1}
        />
        <MonetizeStackCard
          id={'home-page__card-game'}
          cardInfo={MONETIZE_DETAILS.game}
          scrollStyles={scrollStyles}
          forwardedRef={ref5}
        />
      </Grid>
      <Grid
        className={'home-page__monetize-details-section-container'}
        item={true}
        xs={10}
        md={8}
        data-qa="monetize-card-details-section"
      >
        <MonetizeCardDetail
          id={'home-page__monetize-sdk'}
          cardInfo={MONETIZE_DETAILS.sdk}
          scrollClass={scrollClass1}
        />
        <MonetizeCardDetail
          id={'home-page__monetize-ops'}
          cardInfo={MONETIZE_DETAILS.ops}
          scrollClass={scrollClass2}
        />
        <MonetizeCardDetail
          id={'home-page__monetize-revenue'}
          cardInfo={MONETIZE_DETAILS.revenue}
          scrollClass={scrollClass3}
        />
        <MonetizeCardDetail
          id={'home-page__monetize-data'}
          cardInfo={MONETIZE_DETAILS.data}
          scrollClass={scrollClass4}
        />
      </Grid>
    </>
  );
}

export { MonetizeCardStackSection };
